/* eslint-disable no-plusplus */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
import * as Yup from 'yup';
import React, { useState } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
// material
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Paper,
  Box,
  Modal,
  TextField,
  LinearProgress,
  Backdrop,
  CircularProgress,
  IconButton,
  Skeleton,
  Snackbar,
  ToggleButtonGroup,
  styled,
  Menu,
  alpha,
  MenuItem,
  TableHead,
  Grid,
} from '@mui/material';
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
} from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Page from '../../../components/Page';
import SeatingPlanEditor from './SeatingPlanEditor';
import withAuthorization from '../../../withAuthorization';

// ----------------------------------------------------------------------

//-----------------------------------------------------------------------

// for modal
const style = {
  position: 'absolute',
  top: '25%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 350,
  width: 500,
  bgcolor: 'background.paper',
  p: 4,
};
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 600,
  bgcolor: 'white',
  border: '1px solid white',
  borderRadius: '5px',
  boxShadow: 0,
  p: 3,
};

// ----------- for more bouton modal
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

function IndexSeatEditor() {

 

  // loading
  const [loading, setLoading] = React.useState(false);

  // page de modification
  const [openModif, setOpenModif] = React.useState(false);
  const handleCloseModif = () => setOpenModif(false);
  const [temp, setTemp] = React.useState([]);

 

  // supression d'un billet
  // Modal deleted
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
 
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  return (
    <Page title="Mes Billets">

          <SeatingPlanEditor
  zones={[
    { id: "vip", label: "VIP", price: 30000, color: "#D4AF37" },
    { id: "standard", label: "Standard", price: 15000, color: "#4CAF50" },
  ]}
  initialSeats={[]}
  onSave={(seats) => console.log("Seats to save:", seats)}
/>

          
    </Page>
  );
}

export default withAuthorization(IndexSeatEditor, "manage_tickets")
